export default __webpack_public_path__ + "static/media/bg3.2ca2e0bf.png";